"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ReceivingAccountNumber = _interopRequireDefault(require("./components/ReceivingAccountNumber.vue"));
var _TransferAccount = _interopRequireDefault(require("./components/TransferAccount.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PaymentSettings',
  components: {
    ReceivingAccountNumber: _ReceivingAccountNumber.default,
    TransferAccount: _TransferAccount.default
  },
  data: function data() {
    return {
      activeName: 'first'
    };
  },
  methods: {
    handleClick: function handleClick(tab, event) {
      console.log(tab, event);
    }
  }
};